import { useMemo } from 'react'
import { themeQuartz, colorSchemeDark } from 'ag-grid-community'
import { useTheme } from '@klear/ui/contexts/theme-context'

export function useKlearAgGridTheme() {
  const { resolvedTheme } = useTheme()
  return useMemo(
    () => (resolvedTheme === 'dark' ? themeQuartz.withPart(colorSchemeDark) : themeQuartz),
    [resolvedTheme]
  )
}
